import React from 'react';
import './footerStyle.scss';
import ShieldImage from '../../assets/images/ico-shield.png';
import DhofarWhiteLogo from '../../assets/images/dhofar-logo-white.png';
import AppStoreLogo from '../../assets/images/app-store.png';
import GooglePlayLogo from '../../assets/images/google-play.png';
import CallAdvisorBanner from '../CallAdvisorBanner/CallAdvisorBanner';

export default function Footer() {
  return (
    <footer className='footer p-0'>
      {/* <div className='footer-top'>
        <div className='row align-items-center'>
          <div className='col-md-1'></div>

          <div className='col-md-4 col-12 mb-2 mb-md-1 footer-query d-flex align-items-center'>
            <img
              src={ShieldImage}
              alt='Shield Icon'
              className='icon me-2 ms-5'
              style={{ height: '50px' }}
            />
            <span className='footer-query-text'>
              In need of Insurance coverage?
            </span>
          </div>

          <div className='col-md-3 bg-light'></div>

          <div className='col-md-2 col-12 footer-helpline text-center py-2'>
            <div className='small'>CALL US ON OUR HELPLINE</div>
            <div className='num text-break fw-bold'>8000 77 77</div>
          </div>
        </div>

      </div> */}
<CallAdvisorBanner/>
      <div className='footer-main container mt-5'>
        <div className='row text-md-start text-center'>
          <div className='col-12 col-md-3 mb-4'>
            <div className='p-1 mb-2'>
              <img
                src={DhofarWhiteLogo}
                alt='logo'
                className='mb-3 ms-3'
                style={{ height: '120px' }}
              />
              <h5>Dhofar Insurance Company S.A.O.G</h5>
            </div>

            <div className='p-1 mb-2'>
              <p className='small mb-1'>P.O. Box 1002</p>
              <p className='small mb-1'>Postal Code 112, Ruwi</p>
              <p className='small mb-1'>Sultanate Of Oman</p>
            </div>

            <div className='p-1'>
              <p className='small mb-1'>Phone: (+968) 24 705 305</p>
              <p className='small mb-1'>Fax: (+968) 24 782 801</p>
              <p className='small mb-2'>Email : dhofar@dhofarinsurance.com</p>
            </div>
          </div>

          {/* Products */}
          <div className='col-md-4 mb-4 text-start'>
            <div className='p-3'>
              <h6 className='mb-3'>PRODUCTS</h6>
              <div className='row'>
                <div className='col-6'>
                  <ul className='list-unstyled small'>
                    <li><a href='https://dhofarinsurance.com/motor-insurance/'>Motor Insurance</a></li>
                    <li>
                      <a href='https://dhofarinsurance.com/life-insurance/'>Life Insurance</a>
                    </li>
                    <li>
                      <a href='https://dhofarinsurance.com/medical-insurance/'>Medical Insurance</a>
                    </li>
                    <li>
                      <a href='https://dhofarinsurance.com/travel-insurance/'>Travel Insurance</a>
                    </li>
                    <li>
                      <a href='https://dhofarinsurance.com/home-contents-insurance/'>Home Contents Insurance</a>
                    </li>
                    <li>
                      <a href='https://dhofarinsurance.com/property-insurance/'>Property Insurance</a>
                    </li>
                    <li>
                      <a href='https://dhofarinsurance.com/liability-insurance/'>Liability Insurance</a>
                    </li>
                    <li>
                      <a href='https://dhofarinsurance.com/marine-insurance/'>Marine Insurance</a>
                    </li>
                  </ul>
                </div>
                <div className='col-6'>
                  <ul className='list-unstyled small'>
                    <li><a href='https://dhofarinsurance.com/energy-insurance/'>Energy Insurance</a></li>
                    <li><a href='https://dhofarinsurance.com/industrial-insurance/'>Industrial Insurance</a></li>
                    <li><a href='https://dhofarinsurance.com/engineering-insurance/'>Engineering Insurance</a></li>
                    <li><a href='https://dhofarinsurance.com/borrowers-life-insurance/'>Borrowers Life Insurance</a></li>
                    <li><a href='https://dhofarinsurance.com/oil-petrochemical-insurance/'>Oil & Petroleum Insurance</a></li>
                    <li><a href='https://dhofarinsurance.com/personal-accident-insurance/'>Personal Accident Insurance</a></li>
                    <li><a href='https://dhofarinsurance.com/workmen-compensation-insurance/'>Workmen’s Compensation</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* QUICK LINKS & CUSTOMER SERVICE */}
          <div className='col-md-4 mb-4 text-start'>
            <div className='p-3'>
              <div className='row'>
                <div className='col-6'>
                  <h6 className='mb-3'>QUICK LINKS</h6>
                  <ul className='list-unstyled small'>
                    <li><a href='https://dhofarinsurance.com/press-release/'>News & Updates</a></li>
                    <li><a href='https://dhofarinsurance.com/quarterly-and-annual-reports/'>Financial Reports</a></li>
                    <li><a href='https://dhofarinsurancecompany.careers.yomly.com/list' target='_blank' rel='noreferrer'>Careers</a></li>
                    <li><a href='https://dhofarinsurance.com/branch-networks/'>Branch Network</a></li>
                    <li><a href='https://dhofarinsurance.com/wp-content/uploads/2023/12/DIC-Whistle-Blower-Policy.pdf' target='_blank' rel='noreferrer'>Whistle Blower Policy</a></li>
                  </ul>
                </div>
                <div className='col-6'>
                  <h6 className='mb-3'>CUSTOMER SERVICE</h6>
                  <ul className='list-unstyled small'>
                    <li><a href='https://dhofarinsurance.com/feedback-and-complaints/'>Feedback & Complaints</a></li>
                    <li><a href='https://dhofarinsurance.com/make-claim/'>Make a Claim</a></li>
                    <li><a href='https://dhofarinsurance.com/request-quote/'>Request a Quote</a></li>
                    <li><a href='https://dhofarinsurance.com/buy-online/'>Buy Online</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row align-items-center justify-content-between text-start py-md-4'>
          <div className='col-12 col-md-6 d-flex align-items-center justify-content-md-start justify-content-center mb-3 mb-md-0'>
            <div className='social-icons'>
              <a
                href='https://api.whatsapp.com/send/?phone=%2B96871998000&text&type=phone_number&app_absent=0'
                target='_blank'
                rel='noopener noreferrer'
                className='social-icon me-2'
              >
                <i className='bi bi-whatsapp'></i>
              </a>
              <a
                href='https://www.facebook.com/DhofarInsurance'
                target='_blank'
                rel='noopener noreferrer'
                className='social-icon me-2'
              >
                <i className='bi bi-facebook'></i>
              </a>
              <a
                href='https://www.instagram.com/dhofarinsurance/'
                target='_blank'
                rel='noopener noreferrer'
                className='social-icon me-2'
              >
                <i className='bi bi-instagram'></i>
              </a>

              <a
                href='https://x.com/InsuranceDhofar'
                target='_blank'
                rel='noopener noreferrer'
                className='social-icon me-2'
              >
                <i className='bi bi-twitter'></i>
              </a>
              <a
                href='https://www.youtube.com/channel/UCpt4ZDQY-SHfGQdz_QVOn1g?view_as=subscriber'
                target='_blank'
                rel='noopener noreferrer'
                className='social-icon me-2'
              >
                <i className='bi bi-youtube'></i>
              </a>
            </div>
          </div>
          <div className='col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-end justify-content-md-start flex-wrap text-center'>
            <a
              href='https://apps.apple.com/us/app/dhofar-insurance/id6448518005'
              target='_blank'
              rel='noreferrer'
              className='me-md-2 mb-2'
            >
              <img
                src={AppStoreLogo}
                alt='App Store'
                className='img-fluid'
                style={{ maxHeight: '60px' }}
              />
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=com.jds.dhofar'
              target='_blank'
              rel='noreferrer'
              className='mb-2'
            >
              <img
                src={GooglePlayLogo}
                alt='Google Play'
                className='img-fluid'
                style={{ maxHeight: '60px' }}
              />
            </a>
          </div>

        </div>
      </div>

      <div className='footer-bottom text-center py-4 small'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-6 text-md-start text-center mb-2 mb-md-0'>
              <p className='mb-0 d-flex align-items-center justify-content-center justify-content-md-start gap-3'>
                <a href='https://dhofarinsurance.com/privacy-policy/'><span>Privacy Policy</span></a>
              </p>
            </div>
            <div className='col-md-6 text-md-end text-center'>
              <p className='mb-0'>
                © Copyright 2023 Dhofar Insurance Company S.A.O.G.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
